// cSpell:ignore xyflow nodrag nopan
import { Pencil } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { useCodeGeneration } from "@/hooks/useCodeGeneration";
import { cn } from "@/lib/utils";

export type NodeEditButtonProps = {
  targetStep: number;
  /** Classes additionnelles (ex. teintes au survol propres à la variante du node). */
  className?: string;
};

export function NodeEditButton({ targetStep, className }: NodeEditButtonProps) {
  const { t } = useTranslation();
  const { setCurrentStep } = useCodeGeneration();

  const stopPointer = (e: React.SyntheticEvent) => {
    e.stopPropagation();
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    setCurrentStep(targetStep);
  };

  const label = t("step5Validation.editNode", "Modifier");

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={handleClick}
      onPointerDown={stopPointer}
      onMouseDown={stopPointer}
      onTouchStart={stopPointer}
      aria-label={label}
      title={label}
      className={cn(
        "nodrag nopan",
        "pointer-events-auto",
        "w-full h-8 justify-center gap-1.5",
        "rounded-none rounded-b-md",
        "text-[11px] font-medium tracking-wide uppercase",
        "text-zinc-500 dark:text-zinc-400",
        "hover:bg-transparent",
        "transition-colors cursor-pointer",
        className,
      )}
    >
      <Pencil className="h-3 w-3" aria-hidden="true" />
      <span>{label}</span>
    </Button>
  );
}
